/* global windowThis, globalThis */

const getRuntimeEnv = () => {
  if (typeof window !== 'undefined' && window.__RAVANA_ENV__) {
    return window.__RAVANA_ENV__;
  }

  if (typeof windowThis !== 'undefined' && windowThis.__RAVANA_ENV__) {
    return windowThis.__RAVANA_ENV__;
  }

  if (typeof globalThis !== 'undefined' && globalThis.__RAVANA_ENV__) {
    return globalThis.__RAVANA_ENV__;
  }

  return {};
};

const readProcessEnv = (key) => {
  if (!key) return undefined;

  const directValue = process.env?.[key];
  if (typeof directValue === 'string' && directValue.trim().length > 0) {
    return directValue;
  }

  if (!key.startsWith('REACT_APP_')) {
    const prefixedKey = `REACT_APP_${key}`;
    const prefixedValue = process.env?.[prefixedKey];
    if (typeof prefixedValue === 'string' && prefixedValue.trim().length > 0) {
      return prefixedValue;
    }
  }

  return undefined;
};

export const getEnvValue = (...keys) => {
  for (const key of keys) {
    const value = readProcessEnv(key);
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }

  const runtimeEnv = getRuntimeEnv();

  for (const key of keys) {
    if (!key) continue;

    const runtimeValue = runtimeEnv[key];
    if (typeof runtimeValue === 'string' && runtimeValue.trim().length > 0) {
      return runtimeValue;
    }

    const normalizedKey = key.startsWith('REACT_APP_')
      ? key.replace('REACT_APP_', '')
      : key;

    const normalizedValue = runtimeEnv[normalizedKey];
    if (typeof normalizedValue === 'string' && normalizedValue.trim().length > 0) {
      return normalizedValue;
    }
  }

  return undefined;
};

export { getRuntimeEnv };
